export function hasPermission(permissionId) {
	const user = JSON.parse(sessionStorage.getItem("DATA_SERVICES_USER") ?? "{}");
	const pageRoles = user?.buttons ?? [];

	const hasPermission = (permissionId) => {
		return pageRoles.includes(permissionId);
	};

	return hasPermission(permissionId);
}
